import { render, staticRenderFns } from "./categoryAnalysis.vue?vue&type=template&id=4578a74e"
import script from "./categoryAnalysis.vue?vue&type=script&lang=js"
export * from "./categoryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports